import ChevronLeftIcon from "Assets/Icons/ChevronLeftIcon";
import ChevronRightIcon from "Assets/Icons/ChevronRight";
import React, { useState } from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import { BASE_URL } from "utilFunctions/Constants/urlConstants";
import PaginationLimit from "utilFunctions/shared/PaginationLimit";
import Paginationpage from "utilFunctions/shared/PaginationPage";
import "./index.css";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import styled from "styled-components";
const DivSelectLimitSpan = styled<any>("span")`
  align-items: center;
  display: flex;
  margin: 5px;
  font-weight: 400;
  font-size: 20px;
  line-height: 17px;
`;
let ItemPerPageArray = [
  { value: 10, label: 10 },
  { value: 50, label: 50 },
  { value: 100, label: 100 },
];
const Paginator = (props: any) => {
  const [limitValue, setLimitValue] = useState(
    props.limit
      ? { label: props.limit, value: props.limit }
      : { value: 10, label: 10 }
  );
  const { screen }: any = useWindowSize();
  const onLimitChange = (value: any) => {
    props.onLimitChange(value.value);
    setLimitValue(limitValue);
  };

  if (props.module == "myBatch") {
    ItemPerPageArray = [
      { value: 10, label: 10 },
      { value: 50, label: 50 },
    ];
  } else {
    ItemPerPageArray = [
      { value: 10, label: 10 },
      { value: 50, label: 50 },
      { value: 100, label: 100 },
    ];
  }
  return (
    <>
      {props.pagination ? (
        <>
          {["xxl", "xl", "lg"].includes(screen) ? (
            <nav aria-label="..." className="d-flex justify-content-between">
              <PaginationLimit
                ItemPerPageArray={ItemPerPageArray}
                totalCount={props.pagination.totalCount}
                limitValue={limitValue}
                limit={props.limit}
                pagination={props.pagination}
                totalPage={props.pagination.totalPage}
                onLimitChange={onLimitChange}
                screen={screen}
              ></PaginationLimit>
              <Pagination
                className="pagination justify-content-end mb-0 align-items-center pr-3"
                listClassName="justify-content-end mb-0"
              >
                <Paginationpage
                  limit={props.limit}
                  isPaneOpen={props.isPaneOpen}
                  module={props.module}
                  setPage={props.setPage}
                  baseUrl={BASE_URL}
                  url={
                    props.pagination.nextPageUrl != undefined &&
                    props.pagination.nextPageUrl != ""
                      ? props.pagination.nextPageUrl
                      : props.pagination.previousPageUrl != undefined &&
                        props.pagination.previousPageUrl != ""
                      ? props.pagination.previousPageUrl
                      : props.pagination.currentPageUrl
                  }
                  fetchData={props.handlePaginationCall}
                  fetchQuestionCount={props.fetchQuestionCount}
                  pagination={props.pagination}
                  setpagination={props.setpagination}
                  totalPage={props.pagination.totalPage}
                />
                <span className="paginatorTotalPage">
                  of {props.pagination.totalPage} pages
                </span>
                <PaginationNode
                  pagination={props.pagination.totalPage}
                  url={
                    props.pagination.previousPageUrl
                      ? props.pagination.previousPageUrl.substring(1)
                      : null
                  }
                  num={"Previous"}
                  isClickable={
                    props.pagination.previousPageUrl != null &&
                    props.pagination.previousPageUrl != ""
                  }
                  triggerFun={props.handlePaginationCall}
                  icon={<ChevronLeftIcon />}
                />
                <PaginationNode
                  pagination={props.pagination}
                  url={
                    props.pagination.nextPageUrl
                      ? props.pagination.nextPageUrl.substring(1)
                      : null
                  }
                  isClickable={
                    props.pagination.nextPageUrl != null &&
                    props.pagination.nextPageUrl != ""
                  }
                  num={"Next"}
                  triggerFun={props.handlePaginationCall}
                  icon={<ChevronRightIcon />}
                />
              </Pagination>
            </nav>
          ) : (
            <nav aria-label="..." className="d-flex justify-content-between">
              <PaginationLimit
                ItemPerPageArray={ItemPerPageArray}
                totalCount={props.pagination.totalCount}
                limitValue={limitValue}
                limit={props.limit}
                pagination={props.pagination}
                totalPage={props.pagination.totalPage}
                onLimitChange={onLimitChange}
                screen={screen}
              ></PaginationLimit>
              <Pagination
                className="pagination justify-content-end mb-0 align-items-center pr-5"
                listClassName="justify-content-end mb-0"
              >
                <PaginationNode
                  pagination={props.pagination.totalPage}
                  url={
                    props.pagination.previousPageUrl
                      ? props.pagination.previousPageUrl.substring(1)
                      : null
                  }
                  num={"Previous"}
                  isClickable={
                    props.pagination.previousPageUrl != null &&
                    props.pagination.previousPageUrl != ""
                  }
                  triggerFun={props.handlePaginationCall}
                  icon={<ChevronLeftIcon />}
                  screen={screen}
                />
                <Paginationpage
                  limit={props.limit}
                  isPaneOpen={props.isPaneOpen}
                  module={props.module}
                  setPage={props.setPage}
                  baseUrl={BASE_URL}
                  url={
                    props.pagination.nextPageUrl != undefined &&
                    props.pagination.nextPageUrl != ""
                      ? props.pagination.nextPageUrl
                      : props.pagination.previousPageUrl != undefined &&
                        props.pagination.previousPageUrl != ""
                      ? props.pagination.previousPageUrl
                      : props.pagination.currentPageUrl
                  }
                  fetchData={props.handlePaginationCall}
                  fetchQuestionCount={props.fetchQuestionCount}
                  pagination={props.pagination}
                  setpagination={props.setpagination}
                  totalPage={props.pagination.totalPage}
                />

                <DivSelectLimitSpan>
                  /{props.pagination.totalPage}
                </DivSelectLimitSpan>
                <PaginationNode
                  pagination={props.pagination}
                  url={
                    props.pagination.nextPageUrl
                      ? props.pagination.nextPageUrl.substring(1)
                      : null
                  }
                  isClickable={
                    props.pagination.nextPageUrl != null &&
                    props.pagination.nextPageUrl != ""
                  }
                  num={"Next"}
                  triggerFun={props.handlePaginationCall}
                  icon={<ChevronRightIcon />}
                  screen={screen}
                />
              </Pagination>
            </nav>
          )}
        </>
      ) : null}
    </>
  );
};
const PaginationNode = (props: any) => {
  return (
    <>
      <PaginationItem className={"show"}>
        <PaginationLink
          onClick={() => {
            props.isClickable &&
              props.triggerFun(
                BASE_URL.substring(0, BASE_URL.length) + props.url
              );
          }}
          className={props.screen == "sm" ? "paginationLinkButton" : ""}
        >
          {props.icon}
          <span className="sr-only">{props.num}</span>
        </PaginationLink>
      </PaginationItem>
    </>
  );
};

export default Paginator;
